const isSimpleFood = (foodOptions) => (
  foodOptions.length === 1
)

export default isSimpleFood